import { getCxmFilmsForComponent, isFilmAvailableForAdvanceBookings } from '@vista/omnichannel-components-domain';
import { FilmCategory } from '@vista-digital/ocapi-types/v1';
import { FilmPromotedTagType } from '../types/type';
export const getPromotedTagTypeForFilm = (filmAvailability, componentId) => {
    const { filmId, siteId, categories } = filmAvailability;
    if (isFilmSponsored(filmId, componentId))
        return FilmPromotedTagType.Sponsored;
    if (isFilmAvailableForAdvanceBookings(filmId, siteId))
        return FilmPromotedTagType.PreBookNow;
    if (categories.includes(FilmCategory.ComingSoon))
        return FilmPromotedTagType.ComingSoon;
    return undefined;
};
const isFilmSponsored = (filmId, componentId) => {
    var _a;
    if (!componentId)
        return false;
    const cxmFilms = (_a = getCxmFilmsForComponent(componentId)) !== null && _a !== void 0 ? _a : [];
    const filmEntity = cxmFilms.find(x => x.id === filmId);
    return (filmEntity === null || filmEntity === void 0 ? void 0 : filmEntity.sponsored) === true;
};
